function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cx from "clsx";
import { styled } from "@mui/material/styles";
import { infoClasses } from "./infoClasses";
import { useStylesCtx } from "./Info";
var InfoCaptionRoot = styled("div", {
  name: "JunInfo",
  slot: "Caption",
  overridesResolver: (props, styles) => styles.caption
})((_ref) => {
  var {
    theme,
    ownerState
  } = _ref;
  return _extends({
    color: theme.palette.text.secondary,
    fontSize: "0.75rem",
    marginBlockStart: "0.5em",
    marginBlockEnd: "0.75em"
  }, ownerState.useStyles(theme).caption);
});
export var InfoCaption = /*#__PURE__*/React.forwardRef(function InfoCaption(props, ref) {
  var {
    children,
    component,
    className
  } = props,
      other = _objectWithoutPropertiesLoose(props, ["children", "component", "className"]);

  var useStyles = useStylesCtx();
  return /*#__PURE__*/React.createElement(InfoCaptionRoot, _extends({
    ref: ref
  }, other, {
    as: component,
    className: cx(infoClasses.caption, className),
    ownerState: _extends({}, props, {
      useStyles
    })
  }), children);
});